import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTimetableStore } from '../TimetableProvider';
import { PickedCardView } from './PickedCardView';

export const CardPreview = observer(() => {
  const pinboardStore = useTimetableStore();
  const pickedCard = pinboardStore.pickedCard;

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        pinboardStore.discardPickedCard();
      }
    }
    // Klick außerhalb von Board und Stapel legt die Karte auf ihre vorherige Position zurück
    // (wie ESC). Klicks ins Board (Zelle → placeCard) bzw. in den Stapel (→ zurück in den Stapel)
    // behandeln ihre Container selbst und werden hier per data-Attribut-Check übersprungen.
    function handleClick(event: MouseEvent) {
      if (!pinboardStore.pickedCard || pinboardStore.conflictModal.conflicts !== null) {
        return;
      }
      const target = event.target as HTMLElement | null;
      // Overlay-Menüs (z.B. react-select) wählen per mousedown aus und entfernen ihr per Portal
      // gerendertes Menü VOR dem click — das Ziel hängt dann nicht mehr im DOM. Solche Klicks sind
      // keine echten „Außerhalb"-Klicks und dürfen die Karte nicht zurücklegen.
      if (target && !target.isConnected) {
        return;
      }
      if (
        target?.closest('[data-timetable-board]') ||
        target?.closest('[data-card-stack]') ||
        // Die Stundenplan-Vorschau behandelt Klicks selbst (Zelle → stecken, Tab → Ressource
        // wechseln). Ohne diese Ausnahme würde jeder Tab-/Fehlklick die Karte zurücklegen.
        target?.closest('[data-timetable-preview]') ||
        // Offenes react-select-Menü (per Portal an body gerendert): Klicks darin sind Bedienung
        // des Dropdowns, kein „Außerhalb"-Klick.
        target?.closest('[class*="menuPortal"]')
      ) {
        return;
      }
      pinboardStore.discardPickedCard();
    }

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('click', handleClick);
    };
  }, [pinboardStore]);

  if (!pickedCard) {
    return <></>;
  }
  return <PickedCardView card={pickedCard} />;
});
